<template>
  <div v-if="showCookiesMessage" class="cookies-accept" role="dialog" aria-label="Cookies">
    <div class="cookies-content">
      <p class="cookies-texto">{{ $t('cookies.message') }}</p>
      <FishButton variante="primario" tamanho="pequeno" @click="acceptCookies">
        {{ $t('cookies.accept') }}
      </FishButton>
    </div>
  </div>
</template>

<script>
/**
 * O aviso de cookies é um BILHETE DE PAPEL no canto, não um modal que embosca o meio da tela.
 *
 * A versão anterior era azul-marinho com borda azul brilhante, flutuava em loop e girava um emoji
 * de cookie por 20 segundos — três violações do D0 numa caixa só, e na primeira coisa que um
 * jogador novo via. Um aviso legal merece a atenção de um aviso legal: canto, papel, um botão.
 */
import { FishButton } from '@/shared/ui';

export default {
  name: 'CookiesAcceptComponent',
  components: { FishButton },
  data() {
    return {
      showCookiesMessage: !localStorage.getItem('cookiesAccepted')
    }
  },
  methods: {
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true');
      this.showCookiesMessage = false;
    }
  }
}
</script>

<style scoped>
.cookies-accept {
  position: fixed;
  bottom: calc(var(--e-8) + 64px); /* acima da barra de navegação */
  left: var(--e-3);
  width: min(320px, calc(100vw - 2 * var(--e-3)));
  z-index: var(--z-aviso, 1000);
}

/* No telefone o canto de baixo é onde mora a ação principal (D11) — o bilhete sobe para debaixo
 * do cabeçalho em vez de cobrir o botão de pescar. Conferido a 360px. */
@media (max-width: 599px) {
  .cookies-accept {
    bottom: auto;
    top: calc(64px + env(safe-area-inset-top, 0px) + var(--e-2));
    left: 50%;
    transform: translateX(-50%);
  }
}

.cookies-content {
  border: var(--moldura-borda) solid transparent;
  border-image: url('/ui/frame-panel.png') var(--moldura-fatia) / var(--moldura-borda) repeat;
  background: var(--papel);
  background-clip: padding-box;
  image-rendering: pixelated;
  color: var(--tinta);
  padding: var(--e-2);
  text-align: center;
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.35);
}

.cookies-texto {
  font-family: var(--fonte-corpo);
  font-size: var(--f-2);
  line-height: var(--lh-prosa);
  margin: 0 0 var(--e-2);
}
</style>
